module.exports = __webpack_public_path__ + "img/NSIA-Banque.eef0378e.jpg";